module.exports = __webpack_public_path__ + "static/media/play-shooting.e253411b.mp3";